var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',_vm._b({staticClass:"mainnav"},'nav',_vm.$attrs,false),[_c('div',{staticClass:"u-flex u-flex-col"},_vm._l((_vm.links),function(link,i){return _c('nav-link',{key:i,staticClass:"mb-12",attrs:{"to":link.to,"icon":link.icon}},[_vm._v(_vm._s(link.label))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }